export default "__VITE_ASSET__06dd2567__"